export default __webpack_public_path__ + "static/live_satellites-3dab175e6e8650b3b95c8bd9602c46a8.png";